export const SET_SOCKET_IO_CLIENT = 'SET_SOCKET_IO_CLIENT'
export const SET_SOCKET_CONNECTING = 'SET_SOCKET_CONNECTING'
export const SET_SOCKET_RECONNECTED = 'SET_SOCKET_RECONNECTED'
export const SET_SOCKET_PRINTER_DESKTOP_SESSIONS = 'SET_SOCKET_PRINTER_DESKTOP_SESSIONS'
export const SET_SOCKET_VOIP_DESKTOP_SESSIONS = 'SET_SOCKET_VOIP_DESKTOP_SESSIONS'
